<form [formGroup]="loginForm" (ngSubmit)="onSubmit()" class="rayalina-auth-form" novalidate>
    <div class="field">
        <label for="ray-login-email">Votre adresse email</label>
        <input
            id="ray-login-email"
            type="email"
            formControlName="email"
            autocomplete="email"
            placeholder="Entrer votre adresse email"
        />
        <span
            class="field-error"
            *ngIf="
                (email?.hasError('required') && email?.touched) ||
                (email?.hasError('email') && email?.dirty) ||
                (formSubmitted && !email?.value)
            "
        >
            Veuillez saisir une adresse email valide.
        </span>
    </div>

    <div class="field">
        <label for="ray-login-password">Mot de passe</label>
        <div class="password-row">
            <input
                id="ray-login-password"
                [type]="isShowPass ? 'text' : 'password'"
                formControlName="password"
                autocomplete="current-password"
                placeholder="Entrer votre mot de passe"
            />
            <button type="button" class="toggle-visibility" (click)="handleShowPass()" [attr.aria-pressed]="isShowPass">
                <i class="bx" [class.bx-show]="!isShowPass" [class.bx-hide]="isShowPass"></i>
            </button>
        </div>
        <span
            class="field-error"
            *ngIf="
                (password?.hasError('required') && password?.touched) ||
                (password?.errors?.['minlength'] && password?.dirty) ||
                (formSubmitted && !password?.value)
            "
        >
            Veuillez saisir un mot de passe (au moins 6 caractères).
        </span>
    </div>

    <div class="form-row-between">
        <a [routerLink]="['/']" fragment="contact" class="muted-link">Mot de passe oublié ?</a>
    </div>

    <p class="form-banner-error" *ngIf="errorMessage">{{ errorMessage }}</p>

    <button type="submit" class="submit-btn" [disabled]="loading">
        {{ loading ? "Connexion…" : "Se connecter" }}
    </button>
</form>
